// extracted by mini-css-extract-plugin
export default {"imageSlider":"Slider_imageSlider__xLqcz","dotslider":"Slider_dotslider__hC-Qa"};